import { useState, useEffect } from "react";
import Modal from "react-modal";
import api from "../../services/api.js";
import { IMaskInput } from "react-imask";
import FloatingMenu from "../../componente/menuflutuante/index.jsx";
import "./style.css";
import Aguarde from "../../../src/componente/aguarde/index.jsx";

Modal.setAppElement("#root");

export default function Venda() {
    const { DateTime } = require("luxon");

    const [cpfBusca, setCpfBusca] = useState("");
    const [nomeVendaBusca, setNomeVendaBusca] = useState("");
    const [codVendaAtual, setCodVendaAtual] = useState(0);
    const [nomeCliente, setNomeCliente] = useState("");
    const [modalVenda, setModalVenda] = useState(false);
    const [modalCadastro, setModalCadastro] = useState(false);
    const [modalLista, setModalLista] = useState(false);
    const [modalListaVenda, setModalListaVenda] = useState(false);
    const [loading, setLoading] = useState(false);
    const [erros, setErros] = useState({});


    const [clientes, setClientes] = useState([]);
    const [buscaClienteModal, setBuscaClienteModal] = useState("");

    const [form, setForm] = useState({
        nome: "",
        cpf: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        telefone: "",
        whatsapp: ""
    });

    const [produtos, setProdutos] = useState([]);
    const [itens, setItens] = useState([]);

    const [codcliente, setCodCliente] = useState(0);
    const [nmCliente, setNmCliente] = useState("");

    const isMobile = window.innerWidth <= 768;

    const [modalProdutos, setModalProdutos] = useState(false);
    const [buscaProdutoModal, setBuscaProdutoModal] = useState("");
    const [selecaoProdutos, setSelecaoProdutos] = useState({});
    const [ordemSelecao, setOrdemSelecao] = useState([]);

    /* ================= UTIL ================= */

    function calcularTotalItem(item) {
        const desconto = item.usoProprio ? (item.percentual || 0) / 100 : 0;
        return item.quantidade * item.preco * (1 - desconto);
    }

    function validarFormulario() {
        let novosErros = {};

        if (!form.nome.trim()) {
            novosErros.nome = "Nome é obrigatório";
        }

        if (!form.endereco.trim()) {
            novosErros.endereco = "Endereço é obrigatório";
        }

        if (!form.numero.trim()) {
            novosErros.numero = "Número é obrigatório";
        }

        if (!form.bairro.trim()) {
            novosErros.bairro = "Bairro é obrigatório";
        }

        if (!form.cidade.trim()) {
            novosErros.cidade = "Cidade é obrigatório";
        }

        if (!form.uf.trim()) {
            novosErros.uf = "UF é obrigatório";
        }

        if (!form.telefone || form.telefone.length < 15) {
            novosErros.telefone = "Telefone é obrigatório";
        }

        setErros(novosErros);

        return Object.keys(novosErros).length === 0;
    }

    /* ================= PRODUTOS ================= */

    const fetchDataProdutos = async () => {
        try {
            setLoading(true);
            const response = await api.get("v1/venda/produto", {
                params: {
                    codfuncionario: localStorage.getItem("tempCodFuncionario"),
                    descricao: buscaProdutoModal,
                    tipo: localStorage.getItem("tempTipo"),
                    codequipe: localStorage.getItem("tempCodEquipe")
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });
            setProdutos(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(fetchDataProdutos, 1000);
        return () => clearTimeout(timeoutId);
    }, [buscaProdutoModal]);

    /* ================= CLIENTE ================= */

    async function buscarCPF() {
        const cpfLimpo = cpfBusca.replace(/\D/g, "");

        try {
            setLoading(true);
            const response = await api.get("/v1/venda/consultacpf", {
                params: {
                    cpf: cpfLimpo,
                    cliente: nomeCliente,
                    codequipe: localStorage.getItem("tempCodEquipe")
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            if (response.data.encontrado === "sim") {
                if (response.data.dados.length === 1) {
                    fetchDataProdutos();
                    setCodCliente(response.data.dados[0].codcliente);
                    setNmCliente(response.data.dados[0].nome);
                    setBuscaProdutoModal("");
                    setItens([]);
                    setModalVenda(true);
                } else {
                    setClientes(response.data.dados);
                    setBuscaClienteModal("");
                    setModalLista(true);
                }
            } else {
                setForm({ ...form, cpf: cpfBusca });
                setModalCadastro(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function buscarClienteVenda() {

        try {
            setLoading(true);
            const response = await api.get("/v1/venda/clientevenda", {
                params: {
                    cliente: nomeVendaBusca,
                    codequipe: localStorage.getItem("tempCodEquipe")
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            if (response.data.encontrado === "sim") {
                if (response.data.dados.length === 1) {
                    buscarVendaExistente(response.data.dados[0].codvenda)
                } else {
                    setClientes(response.data.dados);
                    setModalListaVenda(true);
                }
            } else {
                alert("Nenhum cliente localizado");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    function selecionarCliente(cliente) {
        fetchDataProdutos();
        setCodCliente(cliente.codcliente);
        setNmCliente(cliente.nome);
        setBuscaProdutoModal("");
        setItens([]);
        setModalVenda(true);
        setModalLista(false);
    }

    function novoCadastroCliente() {

        // Abre o cadastro manualmente
        // a partir da lista de clientes.

        setForm(prev => ({
            ...prev,

            // Se estiver vindo da busca por nome,
            // utiliza o nome pesquisado.
            nome:
                nomeCliente.trim() ||
                nomeVendaBusca.trim(),

            // Mantém o CPF que estiver na pesquisa.
            cpf: cpfBusca
        }));

        // Limpa mensagens de validação anteriores.
        setErros({});

        // Fecha a lista.
        setModalLista(false);

        // Abre o cadastro.
        setModalCadastro(true);
    }

    async function buscarCEP() {
        if (form.cep.replace(/\D/g, "").length !== 8) return;

        const { data } = await api.get(
            `https://viacep.com.br/ws/${form.cep.replace(/\D/g, "")}/json/`
        );

        setForm({
            ...form,
            endereco: data.logradouro || "",
            bairro: data.bairro || "",
            cidade: data.localidade || "",
            uf: data.uf || ""
        });
    }

    async function salvarCliente() {
        try {
            setLoading(true);
            const response = await api.post("v1/venda/cliente", {
                form,
                codusuario: localStorage.getItem("tempCodUsuario"),
                codequipe: localStorage.getItem("tempCodEquipe"),
                codvendedor: localStorage.getItem("tempCodFuncionario")
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            setCodCliente(response.data.codcliente);
            setNmCliente(form.nome);
            setModalCadastro(false);
            setModalVenda(true);
            setItens([]);
            fetchDataProdutos();
            setBuscaProdutoModal("");
        } catch {
            alert("Erro ao salvar cliente");
        } finally {
            setLoading(false);
        }
    }

    async function buscarVendaExistente(acodvenda) {
        if (!acodvenda) return;

        try {
            setLoading(true);

            const response = await api.get("v1/venda/consultavenda", {
                params: {
                    codvenda: acodvenda
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            setModalListaVenda(false);

            const venda = response.data;

            setCodVendaAtual(venda.codvenda);
            setCodCliente(venda.codcliente);
            setNmCliente(venda.nome);

            const itensConvertidos = venda.itens.map(item => ({
                codvendaitens: item.codvendaitem,
                codproduto: item.codproduto,
                descricao: item.descricao,
                quantidade: item.qtde,
                preco: Number(item.vlunit),
                total: Number(item.total),
                usoProprio: item.usoproprio === "S",
                percentual: Number(item.percusoproprio || 0),
                estoque: 9999,
                codvendaitem: Number(item.codvendaitem || 0)
            }));

            setItens(itensConvertidos);

            fetchDataProdutos();
            setModalVenda(true);

        } catch (error) {
            alert("Venda não encontrada.");
        } finally {
            setLoading(false);
        }
    }

    /* ================= ITENS ================= */

    async function removerProduto(codproduto) {
        const item = itens.find(i => i.codproduto === codproduto);
        if (!item) return;

        

        // Se o item ainda não existe no banco,
        // apenas remove do array.
        if (!item.codvendaitens || Number(item.codvendaitens) === 0) {
            setItens(prev =>
                prev.filter(i => i.codproduto !== codproduto)
            );

            return;
        }

        try {
            setLoading(true);

            // Item já existe no banco.
            // Solicita a exclusão no servidor.
            await api.delete("v1/vendaitens", {
                params: {
                    codvendaitens: item.codvendaitens
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`
                }
            });

            // Só remove do array depois que a API confirmar.
            setItens(prev =>
                prev.filter(i => i.codproduto !== codproduto)
            );

        } catch (error) {
            console.error("Erro ao excluir item da venda:", error);

            alert(
                error?.response?.data?.mensagem ||
                "Não foi possível excluir o item da venda."
            );

        } finally {
            setLoading(false);
        }
    }

    function selecionarProduto(produto, marcado) {
        setSelecaoProdutos(prev => {
            const copia = { ...prev };

            if (marcado) {
                copia[produto.codproduto] = {
                    produto,
                    quantidade: 1
                };
            } else {
                delete copia[produto.codproduto];
            }

            return copia;
        });

        setOrdemSelecao(prev => {
            if (marcado) {
                // Adiciona no final, mantendo exatamente a ordem da seleção
                return [...prev, produto.codproduto];
            } else {
                // Remove da ordem quando desmarcar
                return prev.filter(cod => cod !== produto.codproduto);
            }
        });
    }

    function alterarQtdSelecao(codproduto, quantidade) {

        setSelecaoProdutos(prev => ({

            ...prev,

            [codproduto]: {
                ...prev[codproduto],
                quantidade
            }

        }));

    }

    function logJsonNodes(obj, path = "") {
        if (typeof obj !== "object" || obj === null) {
            console.log(`${path}: ${obj}`);
            return;
        }

        if (Array.isArray(obj)) {
            obj.forEach((item, index) => {
                logJsonNodes(item, `${path}[${index}]`);
            });
        } else {
            Object.entries(obj).forEach(([key, value]) => {
                const newPath = path ? `${path}.${key}` : key;
                logJsonNodes(value, newPath);
            });
        }
    }

    function adicionarProdutosSelecionados() {
        let lista = [...itens];

        ordemSelecao.forEach(codproduto => {
            const item = selecaoProdutos[codproduto];

            if (!item) return;

            const existente = lista.find(
                i => i.codproduto === item.produto.codproduto
            );

            if (existente) {
                existente.quantidade += item.quantidade;
                existente.total = calcularTotalItem(existente);
            } else {

                const novo = {
                    ...item.produto,
                    quantidade: item.quantidade,
                    usoProprio: false,
                    percentual: 0,
                    codvendaitens: 0
                };
                novo.total = calcularTotalItem(novo);
                lista.push(novo);
            }
        });
        setItens(lista);

        setSelecaoProdutos({});
        setOrdemSelecao([]);

        setBuscaProdutoModal("");
        setModalProdutos(false);
    }

    function alterarTipoItem(codproduto) {
        setItens(itens.map(i => {
            if (i.codproduto !== codproduto) return i;

            const uso = !i.usoProprio;
            const atualizado = {
                ...i,
                usoProprio: uso,
                percentual: uso ? i.percentual : 0
            };

            atualizado.total = calcularTotalItem(atualizado);
            return atualizado;
        }));
    }

    function alterarQtd(codproduto, qtd) {
        setItens(itens.map(i => {
            if (i.codproduto !== codproduto) return i;
            const atualizado = { ...i, quantidade: qtd };
            atualizado.total = calcularTotalItem(atualizado);
            return atualizado;
        }));
    }

    function alterarPreco(codproduto, preco) {
        setItens(itens.map(i => {
            if (i.codproduto !== codproduto) return i;
            const atualizado = { ...i, preco: preco };
            atualizado.total = calcularTotalItem(atualizado);
            return atualizado;
        }));
    }

    function alterarPercentual(codproduto, valor) {
        const percentual = Math.min(Math.max(valor, 0), 30);

        setItens(itens.map(i => {
            if (i.codproduto !== codproduto) return i;
            const atualizado = { ...i, percentual };
            atualizado.total = calcularTotalItem(atualizado);
            return atualizado;
        }));
    }

    /* ================= VENDA ================= */

    async function salvarVenda() {
        try {
            setLoading(true);
            await api.post("v1/venda/venda", {
                codvenda: codVendaAtual,
                itens,
                codusuario: localStorage.getItem("tempCodUsuario"),
                codvendedor: localStorage.getItem("tempCodFuncionario"),
                codcliente,
                total: totalVenda,
                tipo: localStorage.getItem("tempTipo"),
                codequipe: localStorage.getItem("tempCodEquipe")
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            alert("Venda salva com sucesso!");
            setCodVendaAtual(0);
            setNomeVendaBusca("");
            setModalVenda(false);
        } catch {
            alert("Erro ao salvar venda");
        } finally {
            setLoading(false);
        }
    }

    const totalItens = itens.reduce((s, i) => s + i.quantidade, 0);
    const totalVenda = itens.reduce((s, i) => s + i.total, 0);

    /* ================= JSX ================= */

    function formatDate(dateStr) {
        return dateStr
            ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
            : "";
    }

    const clientesFiltrados = clientes.filter((cliente) => {
        const busca = buscaClienteModal.toLowerCase().trim();

        if (!busca) return true;

        return (
            (cliente.nome || "").toLowerCase().includes(busca) ||
            (cliente.cpf || "").toLowerCase().includes(busca)
        );
    });

    return (
        <div className="container py-4 d-flex flex-column align-items-center">
            <FloatingMenu />

            <h4 className="mb-3 text-center">Venda</h4>

            <div className="card p-3 shadow-sm" style={{ maxWidth: 380, width: "100%" }}>
                <label>Nome da cliente</label>

                <input
                    className="form-control"
                    type="text"
                    value={nomeCliente}
                    onChange={(v) => setNomeCliente(v.target.value)}
                />

                <label>CPF da cliente</label>

                <IMaskInput
                    mask="000.000.000-00"
                    className="form-control"
                    value={cpfBusca}
                    onAccept={(v) => setCpfBusca(v)}
                />

                <button
                    className="btn btn-primary mt-3 w-100"
                    onClick={() => buscarCPF()}
                >
                    Buscar
                </button>

                <label className="mt-2">Nome do cliente da Venda</label>

                <input
                    className="form-control"
                    type="text"
                    value={nomeVendaBusca}
                    onChange={(e) => setNomeVendaBusca(e.target.value)}
                />

                <button
                    className="btn btn-warning mt-2 w-100"
                    onClick={() => buscarClienteVenda()}
                >
                    Continuar Venda
                </button>
            </div>

            {loading && <Aguarde />}

            {/* MODAL CADASTRO */}
            <Modal
                isOpen={modalCadastro}
                onRequestClose={() => setModalCadastro(false)}
                overlayClassName="modal-overlay"
                className="modal-box"
            >
                <div className="modal-header">
                    <h5>Cadastro de Cliente</h5>
                    <button
                        className="btn-close"
                        onClick={() => setModalCadastro(false)}
                    />
                </div>

                <div className="modal-body">
                    <div className="row g-2">

                        <div className="col-12">
                            <input
                                className={`form-control ${erros.nome ? "is-invalid" : ""}`}
                                placeholder="Nome"

                                value={form.nome}
                                onChange={(e) => {
                                    setForm({ ...form, nome: e.target.value });
                                    setErros({ ...erros, nome: null });
                                }}
                            />

                            {erros.nome && (
                                <div className="invalid-feedback">
                                    {erros.nome}
                                </div>
                            )}
                        </div>

                        <div className="col-6">
                            <IMaskInput
                                mask="000.000.000-00"
                                className="form-control"
                                placeholder="CPF"
                                value={form.cpf}
                                onAccept={(v) =>
                                    setForm({ ...form, cpf: v })
                                }
                            />
                        </div>

                        <div className="col-6">
                            <IMaskInput
                                mask="00000-000"
                                className="form-control"
                                placeholder="CEP"
                                value={form.cep}
                                onAccept={(v) =>
                                    setForm({ ...form, cep: v })
                                }
                                onBlur={buscarCEP}
                            />
                        </div>

                        <div className="col-8">
                            <input
                                className={`form-control ${erros.endereco ? "is-invalid" : ""}`}
                                placeholder="Endereço"
                                value={form.endereco}
                                onChange={(e) => {
                                    setForm({ ...form, endereco: e.target.value });
                                    setErros({ ...erros, endereco: null });
                                }}
                            />

                            {erros.endereco && (
                                <div className="invalid-feedback">
                                    {erros.endereco}
                                </div>
                            )}
                        </div>

                        <div className="col-4">
                            <input
                                className={`form-control ${erros.numero ? "is-invalid" : ""}`}
                                placeholder="Número"
                                value={form.numero}
                                onChange={(e) => {
                                    setForm({ ...form, numero: e.target.value });
                                    setErros({ ...erros, numero: null });
                                }}
                            />

                            {erros.numero && (
                                <div className="invalid-feedback">
                                    {erros.numero}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <input
                                className="form-control"
                                placeholder="Complemento"
                                value={form.complemento}
                                onChange={(e) =>
                                    setForm({ ...form, complemento: e.target.value })
                                }
                            />
                        </div>

                        <div className="col-6">
                            <input
                                className={`form-control ${erros.bairro ? "is-invalid" : ""}`}
                                placeholder="Bairro"
                                value={form.bairro}
                                onChange={(e) => {
                                    setForm({ ...form, bairro: e.target.value });
                                    setErros({ ...erros, bairro: null });
                                }}
                            />

                            {erros.bairro && (
                                <div className="invalid-feedback">
                                    {erros.bairro}
                                </div>
                            )}
                        </div>

                        <div className="col-4">
                            <input
                                className={`form-control ${erros.cidade ? "is-invalid" : ""}`}
                                placeholder="Cidade"
                                value={form.cidade}
                                onChange={(e) => {
                                    setForm({ ...form, cidade: e.target.value });
                                    setErros({ ...erros, cidade: null });
                                }}
                            />

                            {erros.cidade && (
                                <div className="invalid-feedback">
                                    {erros.cidade}
                                </div>
                            )}
                        </div>

                        <div className="col-2">
                            <input
                                className={`form-control ${erros.uf ? "is-invalid" : ""}`}
                                placeholder="UF"
                                value={form.uf}
                                onChange={(e) => {
                                    setForm({ ...form, uf: e.target.value });
                                    setErros({ ...erros, uf: null });
                                }}
                            />

                            {erros.uf && (
                                <div className="invalid-feedback">
                                    {erros.uf}
                                </div>
                            )}
                        </div>

                        <div className="col-6">
                            <IMaskInput
                                mask="(00) 00000-0000"
                                className={`form-control ${erros.telefone ? "is-invalid" : ""}`}
                                placeholder="Telefone"
                                value={form.telefone}
                                onAccept={(value) => {
                                    setForm({ ...form, telefone: value });
                                    setErros({ ...erros, telefone: null });
                                }}
                            />

                            {erros.telefone && (
                                <div className="invalid-feedback">
                                    {erros.telefone}
                                </div>
                            )}
                        </div>

                        <div className="col-6">
                            <IMaskInput
                                mask="(00) 00000-0000"
                                className="form-control"
                                placeholder="WhatsApp"
                                value={form.whatsapp}
                                onAccept={(v) =>
                                    setForm({ ...form, whatsapp: v })
                                }
                            />
                        </div>

                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setModalCadastro(false)}
                    >
                        Cancelar
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={() => {
                            if (validarFormulario()) {
                                salvarCliente();
                            }
                        }}
                    >
                        Salvar
                    </button>
                </div>
            </Modal>

            {/* MODAL VENDA */}
            <Modal
                isOpen={modalVenda}
                onRequestClose={() => setModalVenda(false)}
                overlayClassName="modal-overlay"
                className="modal-box modal-lg"
            >
                <div className="modal-header">
                    <h5>Venda para: {nmCliente}</h5>

                    <button
                        className="btn-close"
                        onClick={() => setModalVenda(false)}
                    />
                </div>

                <div className="modal-body">
                    <button
                        className="btn btn-primary mb-3"
                        onClick={() => setModalProdutos(true)}
                    >
                        + Adicionar Produtos
                    </button>

                    {isMobile ? (
                        <div>
                            {itens.map(i => (
                                <div key={i.codproduto} className="card mb-2">
                                    <div className="card-body">
                                        <div className="item-header">
                                            <strong>{i.descricao}</strong>

                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => removerProduto(i.codproduto)}
                                            >
                                                🗑
                                            </button>
                                        </div>

                                        <div className="mt-2">
                                            <input
                                                type="number"
                                                className="form-control"
                                                min="1"
                                                max={i.estoque}
                                                value={i.quantidade}
                                                onChange={e => alterarQtd(i.codproduto, Number(e.target.value))}
                                            />
                                        </div>

                                        <div className="mt-2">
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={i.preco}
                                                onChange={e => alterarPreco(i.codproduto, Number(e.target.value))}
                                            />
                                        </div>

                                        <div className="form-check mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={i.usoProprio}
                                                onChange={() => alterarTipoItem(i.codproduto)}
                                            />
                                            <label className="form-check-label">Uso Próprio</label>
                                        </div>

                                        {i.usoProprio && (
                                            <input
                                                type="number"
                                                className="form-control mt-2"
                                                max={30}
                                                min={0}
                                                placeholder="Percentual (máx 30%)"
                                                value={i.percentual}
                                                onChange={e =>
                                                    alterarPercentual(i.codproduto, Number(e.target.value))
                                                }
                                            />
                                        )}

                                        <div className="mt-2">
                                            <strong>Total: R$ {Number(i.total || 0).toFixed(2)}</strong>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Produto</th>
                                    <th>Qtd</th>
                                    <th>Preço</th>
                                    <th>Uso Próprio</th>
                                    <th>%</th>
                                    <th>Total</th>
                                    <th width="70">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens.map(i => (
                                    <tr key={i.codproduto}>
                                        <td>{i.descricao}</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min="1"
                                                value={i.quantidade}
                                                onChange={e =>
                                                    alterarQtd(i.codproduto, Number(e.target.value))
                                                }
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min="1"
                                                value={i.preco}
                                                onChange={e =>
                                                    alterarPreco(i.codproduto, Number(e.target.value))
                                                }
                                            />
                                        </td>
                                        <td className="text-center">
                                            <input
                                                type="checkbox"
                                                checked={i.usoProprio}
                                                onChange={() => alterarTipoItem(i.codproduto)}
                                            />
                                        </td>
                                        <td>
                                            {i.usoProprio && (
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    max={30}
                                                    min={0}
                                                    value={i.percentual}
                                                    onChange={e =>
                                                        alterarPercentual(i.codproduto, Number(e.target.value))
                                                    }
                                                />
                                            )}
                                        </td>
                                        <td>R$ {Number(i.total || 0).toFixed(2)}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                title="Excluir produto"
                                                onClick={() => removerProduto(i.codproduto)}
                                            >
                                                🗑
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <div className="alert alert-info mt-2">
                        <strong>Itens:</strong> {totalItens} <br />
                        <strong>Total:</strong> R$ {totalVenda}
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setModalVenda(false)}
                    >
                        Fechar
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={() => salvarVenda()}
                    >
                        Finalizar
                    </button>
                </div>
            </Modal>

            {/* MODAL PRODUTOS */}
            <Modal
                isOpen={modalProdutos}
                onRequestClose={() => setModalProdutos(false)}
                overlayClassName="modal-overlay"
                className="modal-box modal-lg"
            >
                <div className="modal-header">
                    <h5>Selecionar Produtos</h5>
                    <button
                        className="btn-close"
                        onClick={() => setModalProdutos(false)}
                    />
                </div>

                <div className="modal-body">
                    <input
                        className="form-control mb-3"
                        placeholder="Buscar produto"
                        value={buscaProdutoModal}
                        onChange={e => setBuscaProdutoModal(e.target.value)}
                    />

                    {
                        produtos
                            .filter(p =>
                                p.descricao
                                    .toLowerCase()
                                    .includes(buscaProdutoModal.toLowerCase())
                            )

                            .map(produto => {
                                const marcado =
                                    selecaoProdutos[produto.codproduto];

                                return (
                                    <div
                                        key={produto.codproduto}
                                        className="produto-card"
                                    >

                                        <div className="produto-info">
                                            <input
                                                type="checkbox"
                                                checked={!!marcado}
                                                onChange={e =>
                                                    selecionarProduto(
                                                        produto,
                                                        e.target.checked
                                                    )
                                                }
                                            />

                                            <div>
                                                <strong>{produto.descricao}</strong>

                                                <div className="produto-detalhes">
                                                    R$ {Number(produto.preco || 0).toFixed(2)} • Estoque: {produto.estoque}
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min={1}
                                                max={produto.estoque}
                                                disabled={!marcado}
                                                value={
                                                    marcado
                                                        ? marcado.quantidade
                                                        : 1
                                                }

                                                onChange={e =>
                                                    alterarQtdSelecao(
                                                        produto.codproduto,
                                                        Number(e.target.value)
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                );
                            })
                    }
                </div>

                <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setModalProdutos(false)}
                    >
                        Cancelar
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={adicionarProdutosSelecionados}
                    >
                        Adicionar
                    </button>
                </div>
            </Modal>

            {/* MODAL CLIENTE */}
            <Modal
                isOpen={modalLista}
                onRequestClose={() => {
                    setModalLista(false);
                    setBuscaClienteModal("");
                }}
                overlayClassName="modal-overlay"
                className="modal-content modal-xl modal-clientes"
            >
                <div className="modal-header-custom">
                    <h5>Selecione o Cliente</h5>

                    <button
                        className="btn-close"
                        onClick={() => {
                            setModalLista(false);
                            setBuscaClienteModal("");
                        }}
                    />
                </div>

                {/* BUSCA LOCAL DOS CLIENTES */}
                <div className="p-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="🔎 Buscar por nome ou CPF..."
                        value={buscaClienteModal}
                        onChange={(e) => setBuscaClienteModal(e.target.value)}
                        autoFocus
                    />
                </div>

                {/* ÁREA COM SCROLL */}
                <div className="modal-body-custom">
                    {clientesFiltrados.length === 0 ? (
                        <div className="text-center text-muted py-4">
                            Nenhum cliente encontrado.
                        </div>
                    ) : (
                        clientesFiltrados.map((cliente) => (
                            <div
                                key={cliente.codcliente}
                                className="cliente-card"
                                onClick={() => selecionarCliente(cliente)}
                            >

                                <div className="d-flex justify-content-between align-items-center gap-2">
                                    <div className="cliente-nome">
                                        {cliente.nome}
                                    </div>

                                    <strong className="text-danger text-nowrap">
                                        Em aberto:{" "}
                                        {Number(cliente.valor || 0).toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL"
                                        })}
                                    </strong>
                                </div>

                                <div className="cliente-info">
                                    <span>
                                        <strong>CPF:</strong> {cliente.cpf}
                                    </span>

                                    <span>
                                        <strong>Equipe:</strong> {cliente.equipe}
                                    </span>
                                </div>

                                <div className="cliente-endereco">
                                    <strong>Endereço:</strong>{" "}
                                    {cliente.endereco}, {cliente.numero} –{" "}
                                    {cliente.bairro} – {cliente.cidade}/{cliente.uf}
                                </div>

                            </div>
                        ))
                    )}
                </div>

                <div className="modal-footer-custom d-flex gap-2">

                    <button
                        className="btn btn-secondary w-100"
                        onClick={() => {
                            setModalLista(false);
                            setBuscaClienteModal("");
                        }}
                    >
                        Cancelar
                    </button>

                    <button
                        className="btn btn-primary w-100"
                        onClick={novoCadastroCliente}
                    >
                        + Novo Cliente
                    </button>

                </div>
            </Modal>

            {/* MODAL CLIENTE VENDA */}
            <Modal
                isOpen={modalListaVenda}
                onRequestClose={() => setModalListaVenda(false)}
                overlayClassName="modal-overlay"
                className="modal-content modal-xl modal-clientes"
            >
                <div className="modal-header-custom">
                    <h5>Selecione a Venda do Cliente</h5>
                    <button
                        className="btn-close"
                        onClick={() => setModalListaVenda(false)}
                    />
                </div>

                {/* ÁREA COM SCROLL */}
                <div className="modal-body-custom">
                    {clientes.map((cliente) => (
                        <div
                            key={cliente.codvenda}
                            className="cliente-card"
                            onClick={() => buscarVendaExistente(cliente.codvenda)}
                        >
                            <div className="cliente-nome">
                                <span>
                                    {cliente.codvenda} - {cliente.nome}
                                </span>

                                <span className="cliente-valor">
                                    {Number(cliente.vltotal).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                </span>
                            </div>

                            <div className="cliente-info">
                                <span><strong>Data:</strong> {formatDate(cliente.dtvenda)}</span>
                                <span><strong>CPF:</strong> {cliente.cpf}</span>
                                <span><strong>Equipe:</strong> {cliente.equipe}</span>
                            </div>

                            <div className="cliente-endereco">
                                <strong>Endereço:</strong> {cliente.endereco}, {cliente.numero} –{" "}
                                {cliente.bairro} – {cliente.cidade}/{cliente.uf}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="modal-footer-custom">
                    <button
                        className="btn btn-secondary w-100"
                        onClick={() => setModalLista(false)}
                    >
                        Cancelar
                    </button>
                </div>
            </Modal>
        </div>
    );
}
